import { defineMessages } from '@sm/intl';

const NAVSUBMENUCOPY = defineMessages({
  PRODUCTS_TITLE: {
    id: 'NavSubmenuCopy.productsTitle',
    defaultMessage: 'Power your curiosity with our data platforms',
    description: '[Type: Label][Vis.: low] - Products title of NavBar submenu'
  },
  SOLUTIONS_TITLE: {
    id: 'NavSubmenuCopy.solutionsTitle',
    defaultMessage: 'Drive business forward with People Powered Data',
    description: '[Type: Label][Vis.: low] - Solutions title of NavBar submenu'
  },
  RESOURCES_TITLE: {
    id: 'NavSubmenuCopy.resourcesTitle',
    defaultMessage: 'Seek the inspiration and expertise you need',
    description: '[Type: Label][Vis.: low] - Resources title of NavBar submenu'
  },
  SURVEYS: {
    id: 'NavSubmenuCopy.surveys',
    defaultMessage: 'Surveys',
    description: '[Type: Label][Vis.: low] - Surveys section of NavBar submenu'
  },
  AUDIENCE: {
    id: 'NavSubmenuCopy.audience',
    defaultMessage: 'Audience',
    description: '[Type: Label][Vis.: low] - Audience section of NavBar submenu'
  },
  AUDIENCE_SUBTITLE: {
    id: 'NavSubmenuCopy.audienceSubtitle',
    defaultMessage: 'Collect survey responses from our global consumer panel',
    description:
      '[Type: Label][Vis.: low] - Audience subtitle of NavBar submenu'
  },
  SURVEYMONKEY_SUBTITLE: {
    id: 'NavSubmenuCopy.SurveyMonkeySubtitle',
    defaultMessage:
      'Create & send surveys with the world’s #1 online survey software',
    description:
      '[Type: Label][Vis.: low] - SurveyMonkey subtitle of NavBar submenu'
  },
  FORMS_AND_WORKFLOWS: {
    id: 'NavSubmenuCopy.formsWorkflows',
    defaultMessage: 'Forms and workflows',
    description:
      '[Type: Label][Vis.: low] - Forms and Workflows section of NavBar submenu'
  },
  APPLY_SUBTITLE: {
    id: 'NavSubmenuCopy.applySubtitle',
    defaultMessage: 'Collect, review & manage applications online',
    description: '[Type: Label][Vis.: low] - Apply Subtitle of NavBar submenu'
  },
  USABILLA_SUBTITLE: {
    id: 'NavSubmenuCopy.usabillaSubtitle',
    defaultMessage: 'Get in-the-moment feedback across all digital channels',
    description: '[Type: Label][Vis.: low] - Usabilla label of NavBar submenu'
  },
  PRODUCTS_LINK: {
    id: 'NavSubmenuCopy.productsLink',
    defaultMessage: 'VIEW ALL PRODUCTS',
    description: '[Type: Label][Vis.: low] - Products Link in NavBar submenu'
  },
  INTEGRATIONS_PLUGINS_LINK: {
    id: 'NavSubmenuCopy.integrationsPluginsLink',
    defaultMessage: 'ADD INTEGRATIONS & PLUG-INS',
    description:
      '[Type: Label][Vis.: low] - Integrations and plugins Link in NavBar submenu'
  },
  VIEW_MORE_LINK: {
    id: 'NavSubmenuCopy.viewMoreLink',
    defaultMessage: 'VIEW MORE',
    description: '[Type: Label][Vis.: low] - View More in NavBar submenu'
  },
  CUSTOMERS: {
    id: 'NavSubmenuCopy.customers',
    defaultMessage: 'Customers',
    description:
      '[Type: Label][Vis.: low] - Customers Section in NavBar submenu'
  },
  CUSTOMERS_SUBTITLE: {
    id: 'NavSubmenuCopy.customersSubtitle',
    defaultMessage: 'Win more business with Customer Powered Data',
    description:
      '[Type: Label][Vis.: low] - Customers subtitle in NavBar submenu'
  },
  EMPLOYEES: {
    id: 'NavSubmenuCopy.employees',
    defaultMessage: 'Employees',
    description:
      '[Type: Label][Vis.: low] - Employees Section in NavBar submenu'
  },
  EMPLOYEES_SUBTITLE: {
    id: 'NavSubmenuCopy.employeesSubtitle',
    defaultMessage: 'Build a stronger workforce with Employee Powered Data',
    description:
      '[Type: Label][Vis.: low] - Employees subtitle in NavBar submenu'
  },
  MARKETS: {
    id: 'NavSubmenuCopy.markets',
    defaultMessage: 'Markets',
    description: '[Type: Label][Vis.: low] - Markets Section in NavBar submenu'
  },
  MARKETS_SUBTITLE: {
    id: 'NavSubmenuCopy.marketsSubtitle',
    defaultMessage: 'Validate business strategy with Market Powered Data',
    description: '[Type: Label][Vis.: low] - Markets subtitle in NavBar submenu'
  },
  CUSTOMER_SATISFACTION: {
    id: 'NavSubmenuCopy.customerSatisfaction',
    defaultMessage: 'Customer Satisfaction',
    description:
      '[Type: Label][Vis.: low] - Customer Satisfaction section in NavBar submenu'
  },
  CUSTOMER_LOYALTY: {
    id: 'NavSubmenuCopy.customerLoyalty',
    defaultMessage: 'Customer Loyalty',
    description:
      '[Type: Label][Vis.: low] - Customer Loyalty section in NavBar submenu'
  },
  EVENT_SURVEYS: {
    id: 'NavSubmenuCopy.eventSurveys',
    defaultMessage: 'Event Surveys',
    description:
      '[Type: Label][Vis.: low] - Event Surveys section in NavBar submenu'
  },
  EMPLOYEE_ENGAGEMENT: {
    id: 'NavSubmenuCopy.employeeEngagement',
    defaultMessage: 'Employee Engagement',
    description:
      '[Type: Label][Vis.: low] - Employee Engagement section in NavBar submenu'
  },
  JOB_SATISFACTION: {
    id: 'NavSubmenuCopy.jobSatisfaction',
    defaultMessage: 'Job Satisfaction',
    description:
      '[Type: Label][Vis.: low] - Job Satisfaction section in NavBar submenu'
  },
  HR_SURVEYS: {
    id: 'NavSubmenuCopy.HRSurveys',
    defaultMessage: 'HR Surveys',
    description:
      '[Type: Label][Vis.: low] - HR Surveys section in NavBar submenu'
  },
  MARKET_RESEARCH: {
    id: 'NavSubmenuCopy.marketResearch',
    defaultMessage: 'Market Research',
    description:
      '[Type: Label][Vis.: low] - Market Research section in NavBar submenu'
  },
  OPINION_POLLS: {
    id: 'NavSubmenuCopy.opinionPolls',
    defaultMessage: 'Opinion Polls',
    description:
      '[Type: Label][Vis.: low] - Opinion Polls section in NavBar submenu'
  },
  CONCEPT_TESTING: {
    id: 'NavSubmenuCopy.conceptTesting',
    defaultMessage: 'Concept Testing',
    description:
      '[Type: Label][Vis.: low] - Concept Testing section in NavBar submenu'
  },
  BLOG: {
    id: 'NavSubmenuCopy.blog',
    defaultMessage: 'Curiosity at Work',
    description: '[Type: Label][Vis.: low] - Blog section in NavBar submenu'
  },
  BLOG_SUBTITLE: {
    id: 'NavSubmenuCopy.blogSubtitle',
    defaultMessage: 'Our blog about surveys, tips for business, & more',
    description: '[Type: Label][Vis.: low] - Blog subtitle in NavBar submenu'
  },
  HELP_CENTER_SUBTITLE: {
    id: 'NavSubmenuCopy.helpCenterSubtitle',
    defaultMessage: 'Survey how-to guides & tutorials ',
    description:
      '[Type: Label][Vis.: low] - Help Center Subtitle in NavBar submenu'
  }
});

export default NAVSUBMENUCOPY;
